export interface Company {
  id: number;
  name: string;
  tagline: string;
  description: string;
  link: string;
  industry: string;
}

export const companies: Company[] = [
  {
    id: 1,
    name: "EiE - Excellence in Education",
    tagline:
      "Transforming educational experience through strategic school improvement.",
    description:
      "EIE delivers accreditation support, school improvement services, and future-ready learning systems for schools across Egypt and the region.",
    link: "https://yasserdawa.com",
    industry: "Education",
  },
  {
    id: 2,
    name: "Massachusetts",
    tagline: "Engineering and IT-driven education development.",
    description:
      "A partner organization focused on constructing and operating schools, institutes, and universities while delivering professional educational services.",
    link: "https://yasserdawa.com",
    industry: "Education Technology",
  },
  {
    id: 3,
    name: "HRD Global Egypt",
    tagline: "Human resources and organizational development consultancy.",
    description:
      "A Kuwait-based consultancy delivering training, HR systems, organizational restructuring, and quality management for education and business.",
    link: "https://yasserdawa.com",
    industry: "Consulting",
  },
  {
    id: 4,
    name: "American Academy (AATC)",
    tagline: "International assessments, language, and teaching services.",
    description:
      "AATC provides language training, management programs, IT education, and international exam administration across Egypt.",
    link: "https://yasserdawa.com",
    industry: "Training",
  },
  {
    id: 5,
    name: "BIG Group",
    tagline: "Integrated furniture, media, and uniforms for schools.",
    description:
      "An Egyptian 360 organization offering modern furniture, corporate media services, and professional uniform manufacturing for educational institutions.",
    link: "https://yasserdawa.com",
    industry: "Facilities",
  },
  {
    id: 6,
    name: "Edmentum",
    tagline: "Digital education solutions for K-12 learning.",
    description:
      "A global company providing flexible online curricula, progress tracking, and hybrid learning tools for schools and teachers.",
    link: "https://www.edmentum.com",
    industry: "Digital Education",
  },
  {
    id: 7,
    name: "T-Line",
    tagline: "Architecture and interior design for school environments.",
    description:
      "A design firm delivering award-winning buildings, interiors, and landscapes for educational, commercial, and residential clients.",
    link: "https://yasserdawa.com",
    industry: "Design",
  },
];
